import _inject from "@stylexjs/stylex/lib/stylex-inject";
var _inject2 = _inject;
import * as stylex from "@stylexjs/stylex";
import { createFileRoute } from "@tanstack/react-router";
import { CalendarDays, CalendarOff, Shield, Sparkles, Swords } from "lucide-react";
import { DashboardAlerts, DashboardQuickStats, getGreeting } from "@/components/dashboard/DashboardSummary";
import { LinkCard } from "@/components/dashboard/LinkCard";
import { TodayEventsStrip } from "@/components/dashboard/today-events-strip";
import { PageIntroSplitHeader } from "@/components/layout/page-intro-split-header";
import { SectionKicker } from "@/components/shared/section-kicker";
import { Card, CardContent } from "@/components/ui/card";
import { DotPattern } from "@/components/ui/dot-pattern";
import { allAdminNavEntries } from "@/lib/admin-nav";
import { useEffectiveIsAdmin } from "@/lib/admin-view-store";
_inject2({
  ltr: ".xrvj5dj{display:grid}",
  priority: 3000
});
_inject2({
  ltr: ".x15iy025{gap:1.25rem}",
  priority: 2000
});
_inject2({
  ltr: "@media (min-width: 768px){.x31j4im.x31j4im{gap:1.5rem}}",
  priority: 2200
});
_inject2({
  ltr: ".x1n2onr6{position:relative}",
  priority: 3000
});
_inject2({
  ltr: ".xb3r6kr{overflow:hidden}",
  priority: 2000
});
_inject2({
  ltr: ".xt5xxpk{border-color:color-mix(in oklch,var(--primary) 10%,transparent)}",
  priority: 2000
});
_inject2({
  ltr: ".x1cpjm7i::before{content:\"\"}",
  priority: 8000
});
_inject2({
  ltr: ".x1hmns74::before{position:absolute}",
  priority: 8000
});
_inject2({
  ltr: ".xxx281p::before{inset:0}",
  priority: 6000
});
_inject2({
  ltr: ".xkk1bqk::before{pointer-events:none}",
  priority: 8000
});
_inject2({
  ltr: ".x1opjqeu::before{background-image:linear-gradient(125deg,color-mix(in oklch,var(--secondary) 65%,transparent) 0%,transparent 45%)}",
  priority: 8000
});
_inject2({
  ltr: ".x13ma1cr{mask-image:radial-gradient(ellipse at top right,black 12%,transparent 75%)}",
  priority: 3000
});
_inject2({
  ltr: ".xc7mnfo{color:color-mix(in oklch,var(--primary) 35%,transparent)}",
  priority: 3000
});
_inject2({
  ltr: ".xuzhngd{opacity:.3}",
  priority: 3000
});
_inject2({
  ltr: ".x14i9o60{max-width:56rem}",
  priority: 4000
});
_inject2({
  ltr: ".x8cw2a4{font-size:3rem}",
  priority: 3000
});
_inject2({
  ltr: ".xo5v014{line-height:1}",
  priority: 3000
});
_inject2({
  ltr: ".x1s688f{font-weight:600}",
  priority: 3000
});
_inject2({
  ltr: "@media (min-width: 768px){.xb8sw5w.xb8sw5w{font-size:3.75rem}}",
  priority: 3200
});
_inject2({
  ltr: ".xj1urod{margin-top:1rem}",
  priority: 4000
});
_inject2({
  ltr: ".xiqf31s{grid-auto-rows:1fr}",
  priority: 3000
});
_inject2({
  ltr: ".x8fetqu{gap:1rem}",
  priority: 2000
});
_inject2({
  ltr: ".x178xt8z{border-top-width:1px}",
  priority: 4000
});
_inject2({
  ltr: ".x13fuv20{border-top-style:solid}",
  priority: 4000
});
_inject2({
  ltr: ".xn6zp9t{border-top-color:color-mix(in oklch,var(--border) 40%,transparent)}",
  priority: 4000
});
_inject2({
  ltr: ".x6gltce{padding-top:1.5rem}",
  priority: 4000
});
_inject2({
  ltr: "@media (min-width: 768px){.x1um9e8z.x1um9e8z{grid-template-columns:repeat(2,minmax(0,1fr))}}",
  priority: 3200
});
_inject2({
  ltr: "@media (min-width: 1024px){.x1i86ep7.x1i86ep7{grid-template-columns:repeat(4,minmax(0,1fr))}}",
  priority: 3200
});
_inject2({
  ltr: "@media (min-width: 1280px){.x1vfva9q.x1vfva9q{grid-template-columns:repeat(6,minmax(0,1fr))}}",
  priority: 3200
});
_inject2({
  ltr: "@media (min-width: 1280px){.x15and55.x15and55{gap:1.25rem}}",
  priority: 2200
});
_inject2({
  ltr: "@media (min-width: 1536px){.xq5ivsv.xq5ivsv{grid-template-columns:repeat(7,minmax(0,1fr))}}",
  priority: 3200
});
const styles = {
  introCard: {
    kVAEAm: "x1n2onr6",
    kVQacm: "xb3r6kr",
    kVAM5u: "xt5xxpk",
    kgeoSG: "x1cpjm7i",
    kEoFBp: "x1hmns74",
    kFcpXp: "xxx281p",
    km8f2m: "xkk1bqk",
    k3DiCg: "x1opjqeu",
    $$css: true
  },
  dotPattern: {
    kX1K2I: "x13ma1cr",
    kMwMTN: "xc7mnfo",
    kSiTet: "xuzhngd",
    $$css: true
  },
  title: {
    ks0D6T: "x14i9o60",
    kGuDYH: "x8cw2a4",
    kLWn49: "xo5v014",
    k63SB2: "x1s688f",
    kfImAy: "xb8sw5w",
    $$css: true
  },
  linksGrid: {
    kVAEAm: "x1n2onr6",
    keoZOQ: "xj1urod",
    k1xSpc: "xrvj5dj",
    kJBjZk: "xiqf31s",
    kOIVth: "x8fetqu",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "xn6zp9t",
    kLKAdn: "x6gltce",
    kkhwRS: "x1um9e8z",
    kuIcIo: "x1i86ep7",
    kbD33z: "x1vfva9q",
    kR67d5: "x15and55",
    kyhXku: "xq5ivsv",
    $$css: true
  }
};
export const Route = createFileRoute("/_authed/")({
  component: Index
});
function Index() {
  const {
    auth
  } = Route.useRouteContext();
  const actualIsAdmin = auth.user?.isAdmin ?? false;
  const isAdmin = useEffectiveIsAdmin(actualIsAdmin);
  const displayName = auth.user?.displayName;
  const label = displayName?.trim() || "Unicorn";
  const greeting = getGreeting();
  const kicker = isAdmin ? "Guild Command" : "Holy Unicorn";
  return <div className="xrvj5dj x15iy025 x31j4im">
      <Card stylexStyle={styles.introCard}>
        <DotPattern width={18} height={18} cx={1.2} cy={1.2} cr={1.1} stylexStyle={styles.dotPattern} />
        <PageIntroSplitHeader kicker={<SectionKicker icon={<Sparkles />}>{kicker}</SectionKicker>} title={`${greeting}, ${label}`} titleStyle={styles.title} metrics={<DashboardQuickStats />} />
        <TodayEventsStrip canOpenEventDetails={isAdmin} />
        <DashboardAlerts />
        <CardContent stylexStyle={styles.linksGrid}>
          <LinkCard to="/guild-war-signup" title={isAdmin ? "My Guild War Signup" : "Guild War Signup"} description={isAdmin ? "Use the member dashboard flow to set your paths, weekly availability, and permanent status" : "Set your weekly guild war availability, update paths, and manage permanent membership"} icon={Swords} featured />
          <LinkCard to="/guild-war-roster" title={isAdmin ? "Published Roster" : "Guild War Roster"} description={isAdmin ? "View the published member-facing roster snapshot for each guild war week" : "See the currently published guild war lineup for your week"} icon={Swords} />
          <LinkCard to="/boss-talents" title={isAdmin ? "Boss Talents" : "My Boss Talents"} description={isAdmin ? "Update your own boss clears without leaving the command surface" : "Mark completed boss talents and keep your progression current"} icon={Shield} />
          <LinkCard to="/events" title={isAdmin ? "Member Events View" : "Guild Events"} description={isAdmin ? "Preview the member-facing event list and roster detail pages" : "Browse upcoming guild events and check roster details"} icon={CalendarDays} />
          <LinkCard to="/absences" title={isAdmin ? "My Absences" : "Absences"} description={isAdmin ? "Log your own time away and keep your current absences visible" : "Let the guild know about upcoming time away, track active absences, and view your history"} icon={CalendarOff} />
          {isAdmin ? allAdminNavEntries.map(entry => <LinkCard key={entry.key} to={entry.to} title={entry.label} description={entry.description} icon={entry.icon} featured={entry.featured} />) : null}
        </CardContent>
      </Card>
    </div>;
}